export { default } from './ImageBubble';
